import { useEffect } from "react";
import { Commons } from "../../helper/CommonService";
import { useNavigate } from "react-router-dom";

function AuthSection() {
    const navigate = useNavigate(); // Initialize the navigate function

    useEffect(() => {
        let isAuth = Commons.IsAuth();
        if (!isAuth) {
            navigate('/');
        }
    }, []);
    return (
        <>

        </>
    );
}

export default AuthSection;